<template>
    <!-- Pasos del registro en el lateral (estilos en bkAuth.css). En escritorio
         van en columna; en tablet y celular, en fila debajo del texto. -->
    <ol class="bk-auth-steps" :aria-label="$t('auth_nuevo.reg.steps_label')">
        <li
            v-for="(clave, i) in pasos"
            :key="clave"
            :class="{ 'is-current': step === i + 1, 'is-done': step > i + 1 }"
            :aria-current="step === i + 1 ? 'step' : null"
        >
            <span class="bk-auth-step-n" aria-hidden="true">{{ step > i + 1 ? '✓' : i + 1 }}</span>
            <span>
                {{ $t(`auth_nuevo.reg.steps.${clave}`) }}
                <span v-if="step > i + 1" class="bk-sr-only">{{ $t('auth_nuevo.reg.step_done') }}</span>
                <span v-else-if="step === i + 1" class="bk-sr-only">{{ $t('auth_nuevo.reg.step_current') }}</span>
            </span>
        </li>
    </ol>
</template>

<script>
export default {
    name: "Progress",
    props: {
        step: {
            type: Number,
            required: true
        }
    },
    data() {
        return { pasos: ['s1', 's2', 's3'] };
    }
}
</script>
